import { Fragment } from 'react'
import { s, h } from '../lib/sx'
import { A } from '../lib/router'
import { PageHero } from '../components/PageHero'
import { copy } from '../content/copy'
import { aboutBody, aboutPanels, timeline, values } from '../content/about'

export function About() {
  return (
    <div>
      <PageHero eyebrow="About" title={copy.about.headline} />

      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,96px) clamp(18px,4vw,32px);display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,340px),1fr));gap:clamp(40px,5vw,80px);')}>
        <div>
          <p style={s('font-size:20px;line-height:1.55;color:#1B2430;margin:0 0 24px;text-wrap:pretty;')}>{aboutBody[0]}</p>
          <p style={s('font-size:16px;line-height:1.7;color:#566070;margin:0 0 18px;')}>{aboutBody[1]}</p>
          <p style={s('font-size:16px;line-height:1.7;color:#566070;margin:0;')}>{aboutBody[2]}</p>
        </div>
        <div style={s('display:flex;flex-direction:column;gap:1px;background:#DCE0E5;border:1px solid #DCE0E5;')}>
          {aboutPanels.map((panel) => (
            <div key={panel.label} style={s('background:#F2F4F6;padding:28px 30px;')}>
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#7E8894;")}>{panel.label}</div>
              <div style={s('font-size:15px;line-height:1.7;color:#1B2430;margin-top:10px;')}>
                {panel.lines.map((line, i) => (
                  <Fragment key={i}>
                    {i > 0 && <br />}
                    {line}
                  </Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section style={s('background:#DCE0E5;')}>
        <div style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,90px) clamp(18px,4vw,32px);')}>
          <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:clamp(26px,3.2vw,36px);letter-spacing:-0.025em;margin:0 0 44px;')}>Our first year, month by month</h2>
          <div style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,170px),1fr));gap:1px;background:#C3C9D1;border-top:2px solid #1B2430;')}>
            {timeline.map((t, i) => (
              <div key={i} style={s('background:#DCE0E5;padding:30px 24px 34px;')}>
                <div style={s('font-family:Archivo,sans-serif;font-weight:800;font-size:30px;letter-spacing:-0.02em;color:#A8500F;')}>{t.year}</div>
                <div style={s('font-size:14.5px;line-height:1.6;color:#38424E;margin-top:14px;')}>{t.text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,96px) clamp(18px,4vw,32px);')}>
        <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:clamp(26px,3.2vw,36px);letter-spacing:-0.025em;margin:0 0 12px;')}>{copy.about.valuesHeading}</h2>
        <p style={s('font-size:16px;color:#566070;max-width:620px;margin:0 0 44px;')}>{copy.about.valuesBlurb}</p>
        <div style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,220px),1fr));gap:24px;')}>
          {values.map((v, i) => (
            <div key={i} style={s('border-top:2px solid #1B2430;padding-top:22px;')}>
              <h3 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:19px;margin:0 0 12px;')}>{v.title}</h3>
              <p style={s('font-size:14.5px;line-height:1.65;color:#566070;margin:0;')}>{v.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={s('background:#1B2430;color:#F2F4F6;')}>
        <div style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,80px) clamp(18px,4vw,32px);display:flex;justify-content:space-between;align-items:center;gap:40px;flex-wrap:wrap;')}>
          <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:34px;letter-spacing:-0.02em;margin:0;max-width:620px;')}>{copy.about.leadershipTeaser}</h2>
          <A href="/leadership" style={s('background:#1F5C99;color:#FFFFFF;padding:16px 28px;font-size:14px;font-weight:600;')} className={h('background:#17497A;color:#FFFFFF;')}>
            Leadership team →
          </A>
        </div>
      </section>
    </div>
  )
}
